<template>
  <div class="container education">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="86" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="ethnicity">
    </back-and-skip>
    <div class="row pt-4 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/education.svg" alt="education">
      </div>
    </div>
    <div class="row pt-4 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('education.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <div class="input-group mb-3">
          <input v-model="education.text"
            :placeholder="$t('education.selectOption')"
            v-on:click="showOptions"
            type="text"
            class="form-control input-select"
            readonly>
          <div class="input-group-append">
            <span class="input-group-text">></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-2 row-next">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
    <modal name="options"
      :adaptive="true"
      :scrollable="true"
      :reset="true">
      <div class="container">
        <div class="row row-option">
          <div class="offset-10 col-2 text-right">
            <i @click="hideOptions" class="fas fa-chevron-down"></i>
          </div>
          <div class="col-12">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-action pb-2"
                @click="selectOption(level)"
                v-for="level in levelEducation"
                :key="level.value">
                {{
                  level.text
                }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      levelEducation: [
        { value: 'not-attend-school', text: this.$t('education.notAttendSchool') },
        { value: 'elementary-school', text: this.$t('education.elementarySchool') },
        { value: 'high-school', text: this.$t('education.highSchool') },
        { value: 'bachelor-degree', text: this.$t('education.bachelor') },
        { value: 'graduate-school', text: this.$t('education.graduate') }
      ],
      education: {
        text: '',
        value: ''
      }
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    showOptions () {
      this.$modal.show('options')
    },
    hideOptions () {
      this.$modal.hide('options')
    },
    selectOption (option) {
      this.education = option
      this.$modal.hide('options')
    },
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.selectOptionError')
        })
      } else {
        const answer = {
          key: 'highest_level_of_education',
          value: this.education.value
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'ethnicity'
        })
      }
    }
  },
  validations: {
    education: {
      value: {
        required
      }
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'education')
  }
}
</script>

<style>
.education .img-question {
  width: 100%;
  height: 28vh;
}

.education .title {
  font-weight: 700;
  font-size: 1.5rem;
}

.education .col-select {
  border-radius: 10px;
  border: 1px solid #c1c1c1;
}

.education .input-select {
  border-right: none;
  border-color: #c1c1c1;
  color: #000;
}

.education .form-control:disabled, .form-control[readonly] {
  background-color: white !important;
}

.education *:focus {
  outline: none;
  box-shadow:none !important;
  border-color: #c1c1c1
}

.education .input-group-text {
  color: #c1c1c1;
  background-color: white;
  opacity: 1;
  border-color: #c1c1c1
}

.education .arrow {
  font: var(--unnamed-font-style-normal) normal normal 30px/35px Quicksand;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: center;
  font: normal normal normal 30px/35px Quicksand;
  color: #C1C1C1;
  opacity: 1;
}

.education input::placeholder {
  color: #C1C1C1;
}

.education .row-next {
  padding-top: 9rem;
}

.education .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

.ethnicity .row-option {
  overflow: auto;
}

.ethnicity .col-option {
  height: 5rem;
  font-size: 1.3rem;
  border-bottom: 1px solid #c1c1c1;
}

@media screen and (device-aspect-ratio: 40/71) {
  .education .img-question {
    width: 100%;
    height: 16vh;
  }

  .education .title {
    font-weight: 700;
    font-size: 1.3rem;
  }

  .education .row-next {
    padding-top: 6rem;
  }

  .education .next {
    min-height: 70px;
  }
}
</style>
